// src/contexts/SuperAdminAuthContext.jsx - FIXED version
import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../utils/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { getCurrentSuperAdmin, isSuperAdminAuthenticated } from '../api/superAdminService';

const SuperAdminAuthContext = createContext();

export function useSuperAdminAuth() {
  return useContext(SuperAdminAuthContext);
}

export function SuperAdminAuthProvider({ children }) {
  const [currentSuperAdmin, setCurrentSuperAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  useEffect(() => {
    let mounted = true; // Track if component is still mounted
    
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!mounted) return; // Prevent state updates if unmounted
      
      try {
        console.log('SuperAdmin auth state changed, user:', user?.uid);
        
        if (user) {
          // Check if this user is a SuperAdmin
          const isSuperAdminUser = await isSuperAdminAuthenticated();
          console.log('Is SuperAdmin user:', isSuperAdminUser);
          
          if (isSuperAdminUser) {
            const superAdminData = await getCurrentSuperAdmin();
            console.log('SuperAdmin data loaded:', superAdminData);
            
            if (mounted) {
              setCurrentSuperAdmin(superAdminData);
              setIsSuperAdmin(true);
            }
          } else {
            console.log('User is not a SuperAdmin');
            if (mounted) {
              setCurrentSuperAdmin(null);
              setIsSuperAdmin(false);
            }
          }
        } else {
          console.log('No user authenticated');
          if (mounted) {
            setCurrentSuperAdmin(null);
            setIsSuperAdmin(false);
          }
        }
      } catch (error) {
        console.error('Error in SuperAdmin auth state change:', error);
        if (mounted) {
          setCurrentSuperAdmin(null);
          setIsSuperAdmin(false);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    });
    
    // Cleanup function
    return () => {
      mounted = false;
      unsubscribe();
    };
  }, []);

  const value = {
    currentSuperAdmin,
    isSuperAdmin,
    loading
  };
  
  console.log('SuperAdminAuthContext value:', value);
  
  return (
    <SuperAdminAuthContext.Provider value={value}>
      {children}
    </SuperAdminAuthContext.Provider>
  );
}